export default __webpack_public_path__ + "static/media/bild-1990.da55c020.jpg";